function getOrganizationName(name: string | undefined): string {
  if (name === undefined) {
    return '';
  }
  return name.toLowerCase().replace(/[^a-zа-яё0-9]/g, '');
}
export { getOrganizationName };
